import { Box } from '@/shared/ui';
import { HintFieldSkeletron } from '../hint-field';

interface IProps {
    hintField?: string;
    hintToLeft?: boolean;
    inModal?: boolean;
}

export const InsuranceListItemSkeleton = ({ hintToLeft, hintField, inModal }: IProps) => {
    return (
        <Box wrapperClassName={`shadow-insuranceSkeleton ${inModal ? '!py-[20px] !px-[10px] xl:!py-[30px] xl:!px-[25px]' : '!p-[25px]'} xl:!p-[30px]`} bgWhite sx={{ width: 426, maxWidth: '100%', borderRadius: '6px' }}>
            <div className='flex flex-col gap-[12px] sm:gap-[24px]'>
                <div className='flex flex-col items-between gap-[6px] xl:gap-[14px]'>
                    <div className='flex justify-between items-center h-[1.6875rem] xl:h-[1.875rem] gap-2'>
                        <h3 className="font-atkinsonBold font-bold text-[20px] sm:text-[22px] tracking-[0.8px] sm:tracking-[0.88px]" data-testid="insurance-skeleton-title">Insurance</h3>
                        <span className="flex-1 max-w-[130px] min-w-0 bg-mint-200 h-full" />
                    </div>
                    <div className="flex justify-between gap-2">
                        <HintFieldSkeletron
                            className="flex-shrink-0"
                            testId="insurance-hint-id"
                            arrowDirection="up"
                            name="Member ID"
                            value="1234567"
                            isActive={hintField === 'cardHolderID'}
                        />
                        <span className="bg-mint-200 h-[21px] flex-1 min-w-0 max-w-[130px]" />
                    </div>
                </div>
                <div className='border-t-[0.5px] border-grey-1000 w-full' />
                <div className="flex flex-col gap-[7px]">
                    <div className="flex justify-between gap-2">
                        <span className="bg-mint-200 h-[21px] flex-1 min-w-0  max-w-[11.875rem]" />
                        <HintFieldSkeletron
                            className="flex-shrink-0"
                            testId="insurance-hint-rx-bin"
                            arrowDirection={hintToLeft ? "left" : "right"}
                            name="Rx BIN"
                            value="123456"
                            isActive={hintField === "provider.bin"}
                        />
                    </div>

                    <div className="flex justify-between gap-2">
                        <span className="bg-mint-200 h-[21px] flex-1 min-w-0  max-w-[11.875rem]" />
                        <HintFieldSkeletron
                            className="flex-shrink-0"
                            testId="insurance-hint-rx-pcn"
                            arrowDirection={hintToLeft ? "left" : "right"}
                            name="Rx PCN"
                            value="1234567789"
                            isActive={hintField === "provider.pcn"}
                        />
                    </div>

                    <div className="flex justify-between gap-2">
                        <span className="bg-mint-200 h-[21px] flex-1 min-w-0  max-w-[11.875rem]" />
                        <HintFieldSkeletron
                            className="flex-shrink-0"
                            testId="insurance-hint-rx-group"
                            arrowDirection={hintToLeft ? "left" : "right"}
                            name="Rx Group"
                            value="123456"
                            isActive={hintField === "groupID"}
                        />
                    </div>
                </div>
            </div>
        </Box>
    );
};
